module.exports = function() {
  return new Worker(__webpack_public_path__ + "5945af2b9d1b317cdecf.worker.js");
};